import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-31" data-mp="3ljd2jo5j9d0">
      <div className="flex h-16 w-16 items-center justify-center rounded-xl border border-bordo-soft/50 bg-ink font-display text-3xl font-black tabular-nums text-plata-soft sm:h-20 sm:w-20 sm:text-4xl" data-id="element-32" data-mp="3l2u3fz5arqab">
        {String(value).padStart(2, '0')}
      </div>
      <span className="mt-2 text-[10px] font-bold uppercase tracking-widest text-white/50" data-id="element-33" data-mp="3c0kuvetla6zk">
        {label}
      </span>
    </div>;
}
export function Countdown() {
  const {
    hh,
    mm,
    ss
  } = useCountdown(23 * 3600 + 59 * 60 + 31);
  return <section aria-label="Cuenta regresiva" className="bg-ink" data-id="element-34" data-mp="372jh99exmzvh">
      <div className="mx-auto max-w-3xl px-5 pt-8 text-center" data-id="element-35" data-mp="374vuj99qwm27">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-bordo-light" data-id="element-36" data-mp="10dmxbi8g0b6f">
          ⏰ Precio de lanzamiento — cierra pronto
        </p>
        <div className="mt-6 flex items-center justify-center gap-3 sm:gap-5" role="timer" aria-live="off" data-id="element-37" data-mp="y16lpc9w89rr">
          <Unit value={hh} label="Horas" data-id="element-38" data-mp="t120j8y1iqv7" />
          <span aria-hidden="true" className="font-display text-3xl font-black text-white/30" data-id="element-39" data-mp="t093x0ssphqs">
            :
          </span>
          <Unit value={mm} label="Min" data-id="element-40" data-mp="12rd77393ze5s" />
          <span aria-hidden="true" className="font-display text-3xl font-black text-white/30" data-id="element-41" data-mp="12sewabmym16i">
            :
          </span>
          <Unit value={ss} label="Seg" data-id="element-42" data-mp="f4ewkm7o70fs" />
        </div>
        <p className="mt-6 text-sm font-semibold text-white/60" data-id="element-43" data-mp="a498fg0lzw2g">
          ⚠️ Después sube $35.000 ARS. No vuelve a este precio.
        </p>

        <div className="mx-auto mt-8 max-w-md" data-id="element-44" data-mp="o0w7boc4gwb0">
          <p className="mb-2 text-left text-xs font-semibold text-white/60" data-id="element-45" data-mp="k15ihq65oq94">
            🔴 Cupos al precio de lanzamiento
          </p>
          <div className="h-3 w-full overflow-hidden rounded-full bg-white/10" role="progressbar" aria-valuenow={68} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos tomados al precio de lanzamiento" data-id="element-46" data-mp="1zgcikr4zow27">
            <div className="h-full w-[68%] rounded-full bg-bordo-soft" data-id="element-47" data-mp="x36ks1cq253l" />
          </div>
          <p className="mt-2 text-right text-xs font-bold text-plata-soft" data-id="element-48" data-mp="1255lf3h2unwu">
            68% tomados — Quedan pocos lugares
          </p>
        </div>
      </div>
    </section>;
}